import { render, staticRenderFns } from "./AudioComponent.vue?vue&type=template&id=3d64305a&scoped=true&"
import script from "./AudioComponent.vue?vue&type=script&lang=js&"
export * from "./AudioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64305a",
  null
  
)

export default component.exports